import {DeviceType} from '@birco/rainmesh-api';
import {ApiFilters} from '../../../core/models/interfaces/api-filters.interface';
import {DeviceResponseDto} from '../models/device-response.interface';

export const FEATURE_NAME = 'deviceState';

export type DeviceSortBy = 'name' | 'lastSeenDate';
export type DeviceSortDir = 'asc' | 'desc';

export interface DeviceState {
  entities: Record<string, DeviceResponseDto>; // Cache for the actual device objects
  error: any | null;
  isLoading: boolean;
  filter: DeviceFilter;
  pages: Record<number, string[]>; // Page number to ruleIds on that page
  totalCount: number;
}

export interface DeviceFilter extends ApiFilters {
  deviceTypes?: DeviceType[];
  isActive?: boolean;
  isOutOfService?: boolean;
  isFavorite?: boolean;
  deviceGroupId?: string;
  sortBy?: DeviceSortBy;
  sortDir?: DeviceSortDir;
}

export const initialState: DeviceState = {
  entities: {},
  filter: {
    page: 0,
    pageSize: 12,
    isOutOfService: false,
    sortBy: 'name',
    sortDir: 'asc',
  },
  pages: {},
  totalCount: 0,
  isLoading: false,
  error: null,
}
